module.exports = __webpack_public_path__ + "static/media/img-location-yunlin-zh.00eb126d.svg";